import * as React from "react";
import { SVGAttributes } from "react";
import { BackwardCompatibleOmit, FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";

interface Props
  extends BackwardCompatibleOmit<SVGAttributes<SVGSVGElement>, "children" | "mask" | "transform"> {
  readonly $isFinished: boolean;
  deletionAllowed: boolean;
}

export default function DeleteIcon(props: Props) {
  return <Icon icon={faXmark} {...props} />;
}

const Icon = styled(FontAwesomeIcon)<Props>`
  color: lightgray;
  cursor: pointer;
  ${(props) => (props.$isFinished ? "color: rgba(0, 0, 0, 0.9);" : "")}
  ${(props) => (props.deletionAllowed ? "" : "color: rgba(255,0,0,0.3);")}
`;
